import { render, staticRenderFns } from "./AutomatedExploitationIssueBody.vue?vue&type=template&id=4e36e3bb&scoped=true"
import script from "./AutomatedExploitationIssueBody.vue?vue&type=script&lang=js"
export * from "./AutomatedExploitationIssueBody.vue?vue&type=script&lang=js"
import style0 from "./AutomatedExploitationIssueBody.vue?vue&type=style&index=0&id=4e36e3bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36e3bb",
  null
  
)

export default component.exports